import React from 'react';

import { StyleSheet, View } from 'react-native';

import { Logo as BrandLogo } from 'components/logo';

import { CartErrorHeading, Heading } from './styled';

interface ICartHeading {
  modalHeading?: string;
}

const styles = StyleSheet.create({
  logoContainer: {
    marginTop: 56,
    height: 55,
  },
});

const HeadingContainer = ({ modalHeading }: ICartHeading = {}) => (
  <Heading alignItems="center">
    <View style={styles.logoContainer}>
      <BrandLogo />
    </View>
    <CartErrorHeading>{modalHeading}</CartErrorHeading>
  </Heading>
);

export default HeadingContainer;
